export const DIGITS_REGEX = /\d+/
export const WORDS_REGEX = /[a-z\u0027\u00E0-\u00FC]{2,}/gi
export const SPACE_REGEX = /\s(?=.+)/
export const INPUT_PARAMETER_PREFIX = /^p\./

export const EMAIL_REGEX = /^([\w-+]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?$)/i
export const DATE_FORMAT_REGEX = /^(\d{2})\/(\d{2})\/(\d{4})$/
export const DATE_REGEX = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
export const CHARACTER_NAME_REGEX = /^[a-z\u0027\u2019\u0020\u00E0-\u00FC]+$/i
export const NUMBER_CHARACTER_NAME_REGEX = /^[0-9a-z\u0027\u2019\u0020\u00E0-\u00FC]+$/i

export const CVC_REGEX = [/\d/, /\d/, /\d/]
export const EXPIRE_DATE_REGEX = [/\d/, /\d/, '/', /\d/, /\d/]
export const ABA_REGEX = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
export const BANK_NUMBER_REGEX = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/
]
export const CREDIT_CARD_REGEX = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const REGEX_4X90 = /4x90/

export const REGEX_START_DATE = /start date/gi
